import {SET, DELETED, ADDED, UPDATED} from './actionTypes';
import update from "immutability-helper";

const initialState = [];

export const reducer = (state = initialState, action) => {
  switch (action.type) {

    case SET:
      return action.news;

    case DELETED:
      return update(state, {
        $unset: [action.news.id]
      });

    case ADDED:
      return {
        ...state,
        [action.news.id]: action.news
      };

    case UPDATED:
      return update(state, {
        [action.news.id]: {
          $set: action.news
        }
      });

    default:
      return state;
  }
};